// Solución inmediata para el problema del popup de newsletter
// Este script se carga con prioridad alta al inicio de la página

(function() {
  // Verificar si la URL contiene customer_posted=true o si ya está guardado en localStorage
  const hasSuccessParam = window.location.search.includes('customer_posted=true');
  const alreadySubscribed = localStorage.getItem('newsletterSubscribed') === 'true';
  
  if (hasSuccessParam || alreadySubscribed) {
    // Guardar en localStorage para futuras visitas
    localStorage.setItem('newsletterSubscribed', 'true');
    
    // Definir función para ocultar popups
    function hideAllPopups() {
      // Ocultar por selectores de clase
      document.querySelectorAll('.popup, .popup-signup, .popup--flyout').forEach(function(el) {
        if (el) {
          el.style.display = 'none !important';
          el.style.visibility = 'hidden !important';
          el.style.opacity = '0 !important';
          el.setAttribute('aria-hidden', 'true');
        }
      });
      
      // También ocultar específicamente por ID
      var specificPopup = document.getElementById('PopupSignupForm-signup_flyout_tX9hef');
      if (specificPopup) {
        var parent = specificPopup.parentNode;
        while (parent && parent !== document.body) {
          if (parent.classList && 
              (parent.classList.contains('popup') || 
              parent.classList.contains('popup-signup') || 
              parent.classList.contains('popup--flyout'))) {
            parent.style.display = 'none !important';
            parent.style.visibility = 'hidden !important';
            parent.style.opacity = '0 !important';
            break;
          }
          parent = parent.parentNode;
        }
      }
    }
    
    // Ejecutar inmediatamente
    hideAllPopups();
    
    // Ejecutar nuevamente después de pequeños intervalos
    setTimeout(hideAllPopups, 100);
    setTimeout(hideAllPopups, 500);
    setTimeout(hideAllPopups, 1000);
    
    // También crear un estilo CSS que oculte los popups
    var style = document.createElement('style');
    style.textContent = `
      .popup-signup, .popup--flyout, .popup-signup.popup--flyout, 
      [id*="PopupSignupForm"], [class*="popup__content"], [class*="popup-signup"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
      }
    `;
    document.head.appendChild(style);
    
    // Sobrescribir cualquier función que pueda mostrar el popup
    var originalSetTimeout = window.setTimeout;
    window.setTimeout = function(callback, time) {
      if (time > 100 && time < 10000) {
        try {
          var callbackStr = callback.toString().toLowerCase();
          if (callbackStr.includes('popup') || callbackStr.includes('newsletter')) {
            return; // Prevenir temporizadores relacionados con popups
          }
        } catch(e) {}
      }
      return originalSetTimeout(callback, time);
    };
  }
})();
